/*@ngInject*/
const CurrentUserModel = function (notificationType) {

    let currentUser,
        authorizations = [],
        registrations = [],
        notificationRegistrations = {};
    this.filterInfoMap = {};

    notificationRegistrations[notificationType.REGULAR] = [];
    notificationRegistrations[notificationType.CHAT] = [];

    this.setCurrentUser = function (newUser) {
        currentUser = newUser;

        authorizations = [];
        _.each(newUser.assignedAuthorizations, function (authorization) {
            authorizations.push(authorization.name);
        });
    };

    this.getCurrentUser = function () {
        return currentUser;
    };

    this.getCurrentUserSimplePrincipalId = function () {
        let currentUserPrincipalId = this.getCurrentUser().principalId,
            separatorIndex;
        if (currentUserPrincipalId) {
            separatorIndex = _.lastIndexOf(currentUserPrincipalId, ':');
            if (separatorIndex > -1) {
                currentUserPrincipalId = currentUserPrincipalId.substring(separatorIndex + 1);
            }
        }

        return currentUserPrincipalId;
    };

    this.reset = function () {
        currentUser = null;
        authorizations = [];
        registrations = [];
        notificationRegistrations = {};
        this.filterInfoMap = {};
    };

    this.addRegistration = function (url) {
        let doAdd = true;
        _.each(registrations, function (registration) {
            if (JSON.stringify(url) === JSON.stringify(registration)) {
                doAdd = false;
            }
        });
        if (doAdd) {
            registrations.push(url);
        }
    };

    this.addNotificationRegistration = function (type, url) {
        let doAdd = true;

        _.each(notificationRegistrations[type], function (registration) {
            if (JSON.stringify(url) === JSON.stringify(registration)) {
                doAdd = false;
            }
        });

        if (doAdd) {
            notificationRegistrations[type].push(url);
        }
    };

    this.getRegistrations = function () {
        return registrations;
    };

    this.getNotificationRegistrations = function (type) {
        return notificationRegistrations[type];
    };

    this.clearRegistrations = function () {
        registrations = [];
    };

    this.clearNotificationRegistrations = function (type) {
        notificationRegistrations[type] = [];
    };

    this.hasAuthorization = function (authorization) {
        return _.includes(authorizations, authorization);
    };
};

angular.module('umCore')
    .service('currentUserModel', CurrentUserModel);
